
import { defineComponent, ref, onMounted } from 'vue';

interface Star {
  id: number;
  left: number;
  top: number;
  delay: number;
  duration: number;
}

export default defineComponent({
  name: 'StarryBackground',
  setup() {
    const stars = ref<Star[]>([]);

    const generateStars = () => {
      const starCount = 150; // Number of stars
      const newStars: Star[] = [];

      for (let i = 0; i < starCount; i++) {
        newStars.push({
          id: i,
          left: Math.random() * 100,
          top: Math.random() * 100,
          delay: Math.random() * 4, // Random delay between 0-4 seconds
          duration: 1.5 + Math.random() * 2.5, // Random duration between 1.5-4 seconds
        });
      }

      stars.value = newStars;
    };

    onMounted(() => {
      generateStars();
    });

    return {
      stars,
    };
  },
});
